import {Parser, array, string, number, record} from '@freckle/parser'
import {type operations} from '@frontrow/console/src/open-api/fancy-api/generated-client'

type DistrictRosterCsvUrlsResponseT =
  operations['getRostersR']['responses'][200]['content']['application/json'][number]

export function parseDistrictRosterCsvUrls(
  response: Array<DistrictRosterCsvUrlsResponseT>
): Array<DistrictRosterCsvUrlsT> {
  return response.map(parse)
}

export type DistrictRosterCsvUrlsT = {
  academicSessionsUrl: string
  classesUrl: string
  coursesUrl: string
  demographicsUrl: string
  enrollmentsUrl: string
  manifestUrl: string
  orgsUrl: string
  usersUrl: string
  tenantFreckleSchoolIds: Array<number>
}

function parse(response: unknown): DistrictRosterCsvUrlsT {
  return Parser.run(
    response,
    record({
      academicSessionsUrl: string(),
      classesUrl: string(),
      coursesUrl: string(),
      demographicsUrl: string(),
      enrollmentsUrl: string(),
      manifestUrl: string(),
      orgsUrl: string(),
      usersUrl: string(),
      tenantFreckleSchoolIds: array(number())
    })
  )
}
